import React, { FC } from 'react';
import { NoPreviewWrapper, NoPreviewText } from './PreviewModal.styled';
import { useTranslate } from '@/translations';
import { Button } from 'antd';

interface NoPreviewProps {
  closeModal: () => void;
}

export const NoPreview: FC<NoPreviewProps> = ({ closeModal }) => {
  const { t } = useTranslate();

  return (
    <NoPreviewWrapper>
      <NoPreviewText>{t('unableToPreviewDocType')}</NoPreviewText>
      <NoPreviewText>{t('pleaseDownloadToView')}</NoPreviewText>
      <Button onClick={closeModal}>{t('ok')}</Button>
    </NoPreviewWrapper>
  );
};
